// Ubicación de perfiles y distancias para la búsqueda de profesionales.
// Las coordenadas las calcula el backend al guardar el perfil (utils/geocoding.js):
// latitude/longitude = domicilio (address_*); office_latitude/office_longitude =
// consultorio del profesional (office_*).

const toNumber = (v) => (v === null || v === undefined || v === "" ? NaN : Number(v));

function joinAddress(street, floor, apt) {
  const s = (street || "").trim();
  if (!s) return "";
  const unit = [floor, apt].map((v) => (v || "").toString().trim()).filter(Boolean).join("");
  return unit ? `${s}, ${unit}` : s;
}

function point(lat, lng, address) {
  const la = toNumber(lat);
  const ln = toNumber(lng);
  return {
    address,
    coords: Number.isFinite(la) && Number.isFinite(ln) ? { lat: la, lng: ln } : null,
  };
}

/** Domicilio del perfil (paciente en "Mi salud", sede de institución). */
export function getHomeLocation(profile) {
  if (!profile) return { address: "", coords: null };
  return point(
    profile.latitude,
    profile.longitude,
    joinAddress(profile.address_street, profile.address_floor, profile.address_apt)
  );
}

/**
 * Lugar de atención del profesional: su consultorio; si no lo cargó, la sede de
 * la institución donde tiene agenda compartida.
 */
export function getDoctorLocation(doctor, institution) {
  const office = point(
    doctor?.office_latitude,
    doctor?.office_longitude,
    joinAddress(doctor?.office_address_street, doctor?.office_address_floor, doctor?.office_address_apt)
  );
  if (office.address) return office;
  return getHomeLocation(institution);
}

/** Distancia en km entre dos { lat, lng } (fórmula de haversine). */
export function distanceKm(a, b) {
  if (!a || !b) return null;
  const R = 6371;
  const rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function formatDistanceKm(km) {
  if (km === null || km === undefined) return "";
  return km < 10 ? km.toFixed(1) : String(Math.round(km));
}
